import React, { useState } from "react";
import { useOnBoarderStyle } from '../styles/OnBoarderSlideStyles';
import { Typography, Button, Container, useMediaQuery } from "@material-ui/core";
import Strings from "../lang/Strings";
import clsx from 'clsx';
import { useTheme } from '@material-ui/core/styles';
import { useCookies } from "react-cookie";
import { Constants } from "../constants/Constants";
import { OperationStatus } from "../enums/OperationStatus";
import Routes from "../constants/Routes";
import { Redirect } from "react-router-dom";
import { useSelector, RootStateOrAny } from "react-redux";
import { LoginState } from '../enums/AuthState';

const FirstIntro = React.forwardRef(function (props: any) {

    // noinspection DuplicatedCode
    const firstIntroClasses = useOnBoarderStyle();
    const componentHeight = props.height;
    const componentWidth = props.width;
    const mobileMode: boolean = props.mode;
    const smallButtonMode = props.buttonMode;
    const theme = useTheme();
    const superSmallVH = useMediaQuery(theme.breakpoints.down(337));

    const [navigateToLogin, setNavigateToLogin] = useState(false);
    const [, setCookie] = useCookies([Constants.ACTIVE_OPERATION_STATUS]);

    const logInState: LoginState = useSelector((state: RootStateOrAny) => state.appReducer[Constants.LOGIN_STATE]);

    const initAuth = () => {
        setCookie(Constants.ACTIVE_OPERATION_STATUS, OperationStatus.DEFAULT)
        setNavigateToLogin(true);
    }

    return (
        <div className={clsx(firstIntroClasses.firstIntro)}
            style={{
                height: componentHeight,
                width: componentWidth ?? '100%',
            }}>
            <Container maxWidth="sm"
                       style={{
                           display: 'flex',
                           flexDirection: 'column',
                           alignItems: 'center',
                           justifyContent: 'center',
                           zIndex: 1,
                           overflow: 'hidden'
                       }}>
                <Typography variant="h1" className={firstIntroClasses.onboarderMsg1} dangerouslySetInnerHTML={{ __html: Strings.ONBOARDING_MSG_1 }}
                    style={{
                        marginTop: mobileMode ? componentHeight * 0.2 : componentHeight * 0.1,
                    }} />
                <img src={require('../images/bitcoin_for_all.png')}  alt={"Bitcoin For All"}/>
                <Typography variant="h3" className={firstIntroClasses.onboaderMsg2} dangerouslySetInnerHTML={{ __html: Strings.ONBOARDING_MSG_2 }}
                    style={{
                        fontSize: superSmallVH ? 20 : 23
                    }} />
                <Button disabled={logInState === LoginState.STARTED} onClick={initAuth} className={smallButtonMode ? firstIntroClasses.getStartedButtonSmall : firstIntroClasses.getStartedButton}>{Strings.GET_STARTED}</Button>
            </Container>
            {
                navigateToLogin &&
                <Redirect to={Routes.LOGIN} />
            }
        </div>
    );
});

export default FirstIntro;
